import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  Stop,
} from 'react-native-svg'

const VerificationPendingFilled = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="url(#b)"
        d="M16.95 4.967a.691.691 0 0 0-.225-.467.686.686 0 0 0-.484-.167c-3.274.217-5.791-2.091-5.816-2.116a.667.667 0 0 0-.934.025c-2.158 2.266-5.7 2.083-5.733 2.083a.686.686 0 0 0-.483.167.69.69 0 0 0-.225.458c-.275 5.408.308 11.167 6.783 12.883a.633.633 0 0 0 .175.025c.059 0 .117 0 .175-.025 6.467-1.716 7.058-7.483 6.784-12.883l-.017.017Zm-6.267 8.375a.93.93 0 0 1-.683.283.918.918 0 0 1-.692-.283.942.942 0 0 1-.275-.692c0-.275.092-.5.275-.692a.918.918 0 0 1 .692-.283.9.9 0 0 1 .683.283.942.942 0 0 1 .275.692c0 .275-.091.5-.275.692Zm.375-5.75-.533 3.1c-.017.175-.075.308-.175.4a.511.511 0 0 1-.359.141.511.511 0 0 1-.358-.141c-.1-.092-.158-.225-.183-.4l-.517-3.109s-.008-.091-.008-.158c0-.3.1-.533.308-.708.208-.175.458-.259.767-.259.308 0 .566.084.767.259.2.175.3.408.3.708 0 .067 0 .117-.009.158v.009Z"
      />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={10.008}
        x2={10.008}
        y1={2.038}
        y2={17.858}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#F3A89E" />
        <Stop offset={1} stopColor="#FF8B7B" />
      </LinearGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default VerificationPendingFilled
